import {Task} from "../models/types";

export class OrderManager {
	// 1. Для новой задачи в колонке: последний order + 10
	static getOrderForNewTask(columnTasks: Task[]): number {
		if (columnTasks.length === 0) return 0;
		const lastTask = this.sortTasksByOrder(columnTasks)[columnTasks.length - 1];
		return lastTask.order + 10;
	}

	// 2. Для вставки между задачами: среднее значение
	static getOrderBetweenTasks(prevTask: Task | null, nextTask: Task | null): number {
		if (!prevTask && !nextTask) return 0;
		if (!prevTask) return nextTask!.order - 10; // В начало
		if (!nextTask) return prevTask.order + 10;  // В конец
    
		// Если разница = 1 или меньше, нужна перевыдача
		if (nextTask.order - prevTask.order <= 1) {
			return -1; // Флаг для перевыдачи
		}
    
		return Math.floor((prevTask.order + nextTask.order) / 2);
	}

	// 3. Проверка необходимости перевыдачи
	static needsReorder(tasks: Task[]): boolean {
		const sorted = this.sortTasksByOrder(tasks);
		for (let i = 1; i < sorted.length; i++) {
			if (sorted[i].order - sorted[i-1].order <= 1) {
				return true;
			}
		}
		return false;
	}

	// 4. Перевыдача order с шагом 10
	static redistributeOrders(tasks: Task[]): Task[] {
		const sorted = this.sortTasksByOrder(tasks);
		return sorted.map((task, index) => ({
			...task,
			order: index * 10
		}));
	}

	// 5. Сортировка задач по order
	static sortTasksByOrder(tasks: Task[]): Task[] {
		return [...tasks].sort((a, b) => a.order - b.order);
	}

	// 6. Получение задач для позиционирования
	static getAdjacentTasks(tasks: Task[], targetIndex: number): {
    prevTask: Task | null,
    nextTask: Task | null
  } {
		const sorted = this.sortTasksByOrder(tasks);
    
		if (targetIndex === 0) {
			return { prevTask: null, nextTask: sorted[0] || null };
		}
    
		if (targetIndex >= sorted.length || targetIndex < 0) {
			return { prevTask: sorted[sorted.length - 1] || null, nextTask: null };
		}
    
		return { 
			prevTask: sorted[targetIndex - 1] || null,
			nextTask: sorted[targetIndex] || null 
		};
	}
}